export default {
    OPEN_MODAL (state, value) {
        state.settingModal.isOpen = value;
        state.settingModal.data.name = null;
        state.settingModal.data.type = null;
        state.settingModal.data.id = null;
    },
    SET_MODAL_DATA (state, data) {
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            state.settingModal.data[keys[i]] = data[keys[i]];
        }
    },
    SET_OPEN_CHANGELOG (state, value) {
        state.changelogOpen = value;
    },
    SET_LOGS_DATA (state, data) {
        state.logs = data;
    },
    SET_PRIORITY_SETTINGS (state, data) {
        state.settings = data;
    },
    SET_SETTINGS_TYPE_OPTIONS (state, data) {
        state.typeOptions = data;
    },
    SET_MODAL_ERRORS (state, data) {
        state.settingModal.errors = data;
    },
};
